export const formName = 'user-details';

// max length of bigint is 9223372036854775807
// js cant handle such numbers when comparing without external lib
// set max length of chars to 18 to ensure it does not pass bigint max value
export const maxNpiLength = 18;
